import { render, staticRenderFns } from "./en-attente.vue?vue&type=template&id=7d81f832"
import script from "./en-attente.vue?vue&type=script&lang=ts"
export * from "./en-attente.vue?vue&type=script&lang=ts"
import style0 from "./en-attente.vue?vue&type=style&index=0&id=7d81f832&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports